// extracted by mini-css-extract-plugin
export var borderRadius = "_e0-4";
export var large = "_e0-3";
export var logoContainer = "_e0-0";
export var nameLogo = "_e0-2";
export var small = "_e0-1";